import { useEffect, useRef, useState } from "react";
import ScrollToTop from "../components/ScrollToTop";
import HelmetComponent from "../components/Helmet";

const Help = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const HelpSection = useRef(null);
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    useEffect(() => {
        if (HelpSection.current) {
            HelpSection.current.scrollIntoView({ behavior: "smooth" });
        }
    }, []);
    return (
        <>
            <div className="max-md:px-4 lg:px-5 xl:px-5 py-4 scroll-mt-[90px]" ref={HelpSection}>
                <HelmetComponent
                    title="Help & Support | Shri Radhe Holidays"
                    description="Get help and travel support from Shri Radhe Holidays regarding bookings, payments, cancellations, refunds, visas, hotels, flights and holiday packages."
                    url="https://www.shriradheholidays.com/help"
                />

                <div className="">
                    <div className="wow fadeInUp" data-wow-delay="1ms">
                        {/* Header Section */}
                        <div className="text-start mb-5">
                            <h1 className="  playfair-display font-extrabold py-[6px] px-2 max-sm:text-xl xl:text-2xl text-white  text-start border-l-8 rounded-r-full bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[70%] xl:w-[50%] transform -skew-x-12"
                                style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
                            >
                                Help & Support
                            </h1>
                            <h1 className="mb-2 mt-4 playfair-display max-md:px-3 lg:px-3 xl:px-3" style={{ fontWeight: "bolder" }}>
                                How Can We <span style={{ color: "#D4AF37" }}>Assist You?</span>
                            </h1>
                            <p className=" text-start mx-auto poppins max-md:px-3 lg:px-3 xl:px-3">
                                At <strong className="text-[#D4AF37]">Shri Radhe Holidays</strong>, we are dedicated to making your travel experience smooth and hassle-free. Below are some frequently asked questions to guide you.
                            </p>
                        </div>

                        {/* Main Content Section */}
                        <div className="row ">
                            <div className="col-lg-16 mx-auto">
                                {/* FAQ Accordion */}
                                <div className="bg-white rounded-lg shadow-sm px-4 mb-5">
                                    <h3 className="h4 mb-4 playfair-display" style={{ fontWeight: "bolder" }}>Frequently Asked Questions</h3>
                                    <div className="accordion">
                                        {faqData.map((faq, index) => (
                                            <div
                                                key={index}
                                                className="border-b last:border-b-0"
                                            >
                                                <button
                                                    className="w-full py-4 px-1 text-left flex justify-between items-center hover:bg-gray-50"
                                                    onClick={() => toggleAccordion(index)}
                                                >
                                                    <span className="font-semibold poppins">{faq.question}</span>
                                                    <span className={`transform transition-transform ${activeIndex === index ? 'rotate-180' : ''}`}>
                                                        ▼
                                                    </span>
                                                </button>
                                                <div className={`poppins transition-all duration-300 ${activeIndex === index ? 'max-h-96 py-4 px-3' : 'max-h-0 overflow-hidden'}`}>
                                                    {faq.answer}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Contact Support Section */}
                                <div className="bg-white rounded-lg shadow-sm px-4 mb-5">
                                    <h3 className="h4 mb-4 playfair-display" style={{ fontWeight: "bolder" }}>Contact Support</h3>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="flex items-center p-4 rounded-lg bg-light">
                                            <div className="bg-primary/10 p-3 rounded-full mr-4">
                                                📞
                                            </div>
                                            <div>
                                                <h4 className="font-semibold playfair-display">Call Us</h4>
                                                <a href="tel:9560070953" className="poppins flex items-center text-black no-underline cursor-pointer poppins">+91 9560070953</a>
                                                <a href="tel:8700308090" className="poppins flex items-center text-black no-underline cursor-pointer poppins">+91 8700308090</a>
                                                <p className="text-sm text-gray-600 mt-2 poppins">Available 24/7</p>
                                            </div>
                                        </div>
                                        <div className="flex items-center p-4 rounded-lg bg-light">
                                            <div className="bg-primary/10 p-3 rounded-full mr-4">
                                                📧
                                            </div>
                                            <div>
                                                <h4 className="font-semibold playfair-display">Email Us</h4>
                                                <p className=" flex items-center poppins"><a href="mailto:shriradheholidayss@gmail.com?subject=Inquiry&body=Hello, I would like to know more about your services." className="no-underline cursor-pointer me-3 font-light text-black  flex justify-center items-center">shriradheholidayss@gmail.com</a></p>
                                                <p className="text-sm text-gray-600 poppins">Response within 24 hours</p>
                                            </div>
                                        </div>
                                        <div className="flex items-center p-4 rounded-lg bg-light">
                                            <div className="bg-primary/10 p-3 rounded-full mr-4">
                                                💬
                                            </div>
                                            <div className="flex flex-col">
                                                <h4 className="font-semibold playfair-display">WhatsApp</h4>
                                                <a
                                                    href={`https://wa.me/919560070953?text=${encodeURIComponent(
                                                        `Hi, I need assistance with my travel plans.Please guide me with suitable options and pricing.`
                                                    )}`} target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="no-underline text-black poppins"
                                                >
                                                    +91 9560070953
                                                </a>
                                                <a
                                                    href={`https://wa.me/918700308090?text=${encodeURIComponent(
                                                        `Hi, I need assistance with my travel plans.Please guide me with suitable options and pricing.`
                                                    )}`} target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="no-underline text-black poppins"
                                                >
                                                    +91 8700308090
                                                </a>
                                                <p className="text-sm text-gray-600 mt-2 poppins">Quick responses</p>
                                            </div>
                                        </div>
                                        <div className="flex items-center p-4 rounded-lg bg-light">
                                            <div className="bg-primary/10 p-3 rounded-full mr-4">
                                                📍
                                            </div>
                                            <div>
                                                <h4 className="font-semibold playfair-display">Address</h4>
                                                <p className="poppins">WB-82,Shakarpur,Laxmi Nagar, New Delhi-110092</p>
                                                <p className="text-sm text-gray-600 poppins">Mon-Sat: 10 AM - 7 PM</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer Section */}
                        {/* <div className="text-center mt-8">
                            <p className="dancing-script-font text-4xl md:text-6xl text-[#86B817] ">
                                Shri Radhe Holidays
                            </p>
                            <p className="text-sm md:text-lg hanuman-regular">
                                Where Every Trip Feels Divine.
                            </p>
                        </div> */}
                    </div>
                </div>
            </div>
            <ScrollToTop />
        </>
    );
};

// FAQ Data
const faqData = [
    {
        question: "How can I plan my trip with Shri Radhe Holidays?",
        answer:
            "You can easily plan your trip by contacting us on WhatsApp or submitting an inquiry on our website. Our team will suggest the best options based on your preferences, budget, and travel dates.",
    },
    {
        question: "How do I book a holiday package?",
        answer:
            "Once you finalize your package with our team, we will guide you through the booking process. You can confirm your booking by making a payment via UPI, bank transfer, or card.",
    },
    {
        question: "Can I customize my holiday package?",
        answer:
            "Yes, all our packages are customizable. You can modify hotels, activities, destinations, duration, and inclusions according to your needs.",
    },
    {
        question: "Do you provide international and domestic packages?",
        answer:
            "Yes, we offer both domestic and international holiday packages including destinations like Dubai, Bali, Thailand, Europe, Goa, and more.",
    },
    {
        question: "What is included in your holiday packages?",
        answer:
            "Our packages typically include flights, hotels, sightseeing, transfers, and visa assistance (for international trips). Inclusions may vary depending on the package.",
    },
    {
        question: "Do you provide visa assistance?",
        answer:
            "Yes, we provide complete visa assistance including document verification, application support, and appointment guidance.",
    },
    {
        question: "What payment methods do you accept?",
        answer:
            "We accept UPI, bank transfer, and credit/debit card payments. Payment details will be shared by our team during booking.",
    },
    {
        question: "Can I book only flights or hotels separately?",
        answer:
            "Yes, you can book individual services like flights, hotels, cabs, or visa assistance without purchasing a full package.",
    },
    {
        question: "What is your cancellation policy?",
        answer:
            "Cancellation charges depend on the package and timing. Generally, 30+ days before travel offers higher refunds, while last-minute cancellations may be non-refundable.",
    },
    {
        question: "How long does it take to get a refund?",
        answer:
            "Refunds are usually processed within 7–10 working days after cancellation approval.",
    },
    {
        question: "Do you offer group tours or family packages?",
        answer:
            "Yes, we offer customized group tours, family vacations, honeymoon packages, and corporate travel solutions.",
    },
    {
        question: "Will I get support during my trip?",
        answer:
            "Yes, our team provides 24x7 support during your trip to ensure a smooth and hassle-free experience.",
    },
    {
        question: "Do you provide travel insurance?",
        answer:
            "Yes, we offer travel insurance options to keep your journey safe and secure.",
    },
    {
        question: "Can I get the best price or discounts?",
        answer:
            "Yes, we provide competitive pricing and special deals. Contact us on WhatsApp to get the best available offers.",
    },
    {
        question: "How can I contact your team quickly?",
        answer:
            "The fastest way is through WhatsApp. You can also call or email us, but WhatsApp gives the quickest response.",
    },
];
export default Help;